import { render, staticRenderFns } from "./SopContent.vue?vue&type=template&id=5e40c745&scoped=true&"
import script from "./SopContent.vue?vue&type=script&lang=ts&"
export * from "./SopContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e40c745",
  null
  
)

export default component.exports